const UPDATE = 'update';
const RESET = 'reset';
const SET = 'set';
const DEFAULT_NUMBER_SLIDE = 0;

const state = {
    currentSlide: DEFAULT_NUMBER_SLIDE
};

const getters = {
    currentSlide: state => state.currentSlide
};

const actions = {
    [UPDATE]: ({ commit }, currentSlide) => {
        commit(SET, currentSlide);
    },
    [RESET]: ({ commit }) => {
        commit(SET, DEFAULT_NUMBER_SLIDE);
    }
};

const mutations = {
    [SET](state, currentSlide) {
        state.currentSlide = currentSlide;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/lobby-current-slide.js